import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Import actions
import * as inviteActions from '../actions/invite-actions';

// Import custom components
import InviteForm from '../components/InviteForm.js';
import InviteList from '../components/InviteList.js';

class InvitePage extends Component {
  componentDidMount() {
    this.props.actions.fetchInvites();
  }

  render() {
    const { errorCreating } = this.props.invites;
    let list;
    if (this.props.invites.fetching) {
      list = (<div>Fetching invites...</div>);
    } else {
      list = (<InviteList invites={this.props.invites.invites} />);
    }

    let inviteHelpText = <div><p>Want to hang out with someone in blobby space? Send them an invite!</p><p>As this is a multiplayer thing, we’re giving you the ability to invite anyone that you would like to try it with. However, you need to give us your word that you’ll only invite nice people. You may run into other people trying our stuff in blobby space and we want to make sure everyone has a pleasant time 😘😘.</p></div>;

    if (errorCreating) {
      inviteHelpText = <p>Looks like we couldn't create your invite. {this.props.invites.errorCreating.description}</p>;
    }

    return (
      <div className="InvitePage container">
        <div className="row">
          <div className="col-md-8 col-md-push-2 InviteForm-wrap">
            <h1>Invite a friend</h1>
            {inviteHelpText}

            <InviteForm addInvite={this.props.actions.createInvite} />
          </div>
        </div>

        <div className="row">
          <div className="col-md-10 col-md-push-1">
            <h3>Past Invites</h3>

            {list}
          </div>
        </div>
      </div>
    );
  }
};

InvitePage.propTypes = {
  invites: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

function mapStateToProps(state, props) {
  return {
    invites: state.invites
  };
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(inviteActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvitePage);



// WEBPACK FOOTER //
// ./src/containers/InvitePage.js